import { render, staticRenderFns } from "./WaitingForReview.vue?vue&type=template&id=c93e4060&"
import script from "./WaitingForReview.vue?vue&type=script&lang=ts&"
export * from "./WaitingForReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports